var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 0.875C3.63672 0.875 0 4.51172 0 9C0 13.4883 3.63672 17.125 8.125 17.125C12.6133 17.125 16.25 13.4883 16.25 9C16.25 4.51172 12.6133 0.875 8.125 0.875ZM8.78906 9.66406H4.375V9H8.125V4H8.78906V9.66406Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFilled);
export default __webpack_public_path__ + "static/media/ClockFilled.169ee17ea96173918d4d883f5ef6b77a.svg";
export { ForwardRef as ReactComponent };